<template>
  <template v-if="show">
    <div class="fixed left-0 top-0 w-full h-full flex justify-center items-center bg-[rgba(0,0,0,0.4)] z-[10000] p-2">
      <div class="w-full max-w-4xl max-h-[90vh] overflow-y-auto bg-[#FFF] rounded border border-[#D1D1D1] p-4">
        <div v-if="!showingConfirmation" class="flex justify-between items-center">
          <div class="font-semibold text-lg text-[#171717]">
            {{ t('propertyReport.modal.title') }}
          </div>
          <div class="cursor-pointer" @click="handleClose">
            <i class="ri-close-line text-lg"></i>
          </div>
        </div>
        <div v-else class="flex justify-end">
          <div class="cursor-pointer" @click="handleClose">
            <i class="ri-close-line text-lg"></i>
          </div>
        </div>
    
        <div class="py-2 text-[#464646]">
          <NewPropertyReportForm :key="componentKey" :redirectToPropertyReports="redirectToPropertyReports" @close="handleClose" @success="onSuccess" @confirmationChanged="onConfirmationChanged" />
        </div>
      </div>
    </div>
  </template>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { getLanguage } from '@/utilities/cookies';
import NewPropertyReportForm from './NewPropertyReportForm.vue'

const { t, locale } = useI18n()
locale.value = getLanguage();

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  redirectToPropertyReports: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue', 'close', 'success'])

const show = ref(props.modelValue)
const componentKey = ref(0)
const showInner = ref(false)
const showingConfirmation = ref(false)

watch(() => props.modelValue, (val) => {
  show.value = val
  if (val) {
    componentKey.value++
    setTimeout(() => {
      showInner.value = true
    }, 100)
  } else {
    showInner.value = false
  }
})

if (props.modelValue) {
  showInner.value = true
}


function handleClose() {
  showInner.value = false
  show.value = false
  emit('update:modelValue', false)
  emit('close')
}

function onSuccess(payload){
  emit('success', payload)
  handleClose()
}

function onConfirmationChanged(isShowing) {
  showingConfirmation.value = isShowing
}
</script>
